import { config } from '@/config/config';

export const isLocalEnv = config.app.env === 'localhost';
export const isDevEnv = config.app.env === 'development';
export const isProdEnv = config.app.env === 'production';
